module.exports = __webpack_public_path__ + "img/gls-icon.7389062.jpg";